import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class BlockSignInHoursInAdvanceError extends ExpectedError {
  static override _class = 'BlockSignInHoursInAdvanceError';

  public constructor() {
    super('BlockSignInHoursInAdvanceError', {
      translationKey: 'BLOCK_SIGNIN_ERROR',
    });
  }
}
